import script from "./WorkgroupTable.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkgroupTable.vue?vue&type=script&setup=true&lang=js"

import "./WorkgroupTable.vue?vue&type=style&index=0&id=31d345ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31d345ca"]])

export default __exports__